import { createSlice } from '@reduxjs/toolkit';
import { getMessagesByConversation, getConversationPreviews, getUnreadConversationCount, getMessagesPaged, getUnreadMessagesByConversation, searchMessagesPaged } from './messagesThunks.js';
import { parseISO, isValid, isSameDay } from 'date-fns';
import socketFactory from '../../utils/socketFactory.js';
const normalizeMessage = (msg) => {
    const m = { ...msg };
    if (!m.roomLabel && m.room_tenant?.label) m.roomLabel = m.room_tenant.label;
    if (!m.roomId && m.room_tenant?.room_id != null) m.roomId = m.room_tenant.room_id;
    if (!m.roomTenantId && m.room_tenant?.id != null) m.roomTenantId = m.room_tenant.id;
    return m;
};


function groupAllItemsByDate(messages = []) {
    const allItems = [];

    messages.forEach(m => {
        if (m.encouragement_id && m.encouragement) {
            allItems.push({
                _type: "encouragement",
                _ts: m.timestamp, 
                data: m
            });
        } else if (m.spark_transaction_id && m.spark_transaction) {
            allItems.push({
                _type: "spark",
                _ts: m.timestamp, 
                data: m
            });
        } else {
            allItems.push({
                _type: "message",
                _ts: m.timestamp,
                data: m
            });
        }
    });

    allItems.sort((a, b) => new Date(a._ts) - new Date(b._ts));

    return allItems.reduce((acc, item) => {
        const date = parseISO(item._ts);
        if (!isValid(date)) return acc;

        const lastDateItem = [...acc].reverse().find(i => i.type === "date");
        const lastDate = lastDateItem ? lastDateItem.date : null;

        if (!lastDate || !isSameDay(parseISO(lastDate), date)) {
            acc.push({ type: "date", date: date.toISOString() });
        }

        // Insérer l'élément formaté dans le feed
        if (item._type === "message") {
            acc.push({ 
                type: "message", 
                message: normalizeMessage(item.data) 
            });
        } else if (item._type === "spark") {
    acc.push({ 
        type: "spark", 
        message: {
            id: `spark-${item.data.spark_transaction.id}`,
            sender_id: item.data.sender_id,          
            timestamp: item.data.timestamp,
            spark: item.data.spark_transaction,
        }
    });
} else if (item._type === "encouragement") {
    acc.push({ 
        type: "encouragement", 
        message: {
            id: `enc-${item.data.encouragement.id}`,
            sender_id: item.data.sender_id,           
            timestamp: item.data.timestamp,
            encouragement: item.data.encouragement,
        }
    });
}

        return acc;
    }, []);
}





const initialState = {
    messageLoading: false,
    previewsLoading: false,
    groupedMessages: [], // Messages for the selected conversation
    localConversations: [], // List of conversation previews
    selectedConversationId: null,
    error: null,
    chatPartner: null,
    //Send Message state
    messageText: '',
    isRoom: false,
    target: null, //Room || User

    /////marks 
    MessagesAsRead: false,
    UnreadConversationCount: 0,

    ///popup
    receivedMessages: [],
    //////////////
    isSent: false,
    received: null,
    pagination: null,
    unreadMessagesByConv: [],
};

const messagesSlice = createSlice({
    name: 'messageHistory',
    initialState,
    reducers: {

        setSelectedConversationId: (state, action) => {
            const id = action.payload;

            if (id === state.selectedConversationId) return;
            state.selectedConversationId = id;
            state.groupedMessages = [];
            state.error = null;
            state.pagination = null;
            if (id) {
            state.messageLoading = true;
            }
            if (!id) {
                state.messageLoading = false;
                state.chatPartner = null;
            }
        },

        setChatPartner: (state, action) => {
            state.chatPartner = action.payload
        },
        clearMessages: (state) => {
            state.groupedMessages = [];
            state.error = null;
            state.pagination = null;
        },
        setMessageText: (state, action) => {
            state.messageText = action.payload
        },
        intializeMessageDialog: (state, action) => {
            state.isRoom = action.payload.isRoom;
            state.target = action.payload.target;
        },
        resetMessageDialog: (state) => {
            state.messageText = '';
            state.isRoom = false;
            state.target = null
        },
        RECIEVE_MESSAGE: (state, action) => {
            const msg = action.payload?.data ?? action.payload;
            if (!msg) return;

            if (state.selectedConversationId === msg.conversation_id) {
              if (msg.encouragement_id && msg.encouragement) {
                    state.groupedMessages.push({
                        type: "encouragement",
                        message: {
                            id: `enc-${msg.encouragement.id}`,
                            sender_id: msg.encouragement.sender_id,
                            timestamp: msg.timestamp,
                            encouragement: msg.encouragement,
                        }
                    });
                } else if (msg.spark_transaction_id && msg.spark_transaction) {
                    state.groupedMessages.push({
                        type: "spark",
                        message: {
                            id: `spark-${msg.spark_transaction.id}`,
                            sender_id: msg.spark_transaction.sender_spark_id,
                            timestamp: msg.timestamp,
                            spark: msg.spark_transaction,
                        }
                    });
                } else {
                    state.groupedMessages.push({
                        type: "message",
                        message: normalizeMessage(msg)
                    });
                }
            }

            const convIndex = state.localConversations.findIndex(
                c => c.conversationId === msg.conversation_id
            );

            if (convIndex !== -1) {
                state.localConversations[convIndex].lastMessage = msg.message;
                state.localConversations[convIndex].lastTimestamp = msg.timestamp;
            }
        },


        MESSAGE_SUCCESS: (state, action) => {
            const payload = action.payload?.data ?? action.payload;
            const fullMessage = payload?.fullMessage ?? payload;
            if (!fullMessage) return;

            const convId = fullMessage.conversation_id;

            const existingConv = state.localConversations.find(
                conv => conv.conversationId === convId
            );

            if (!existingConv) {
                state.localConversations.unshift({
                    conversationId: convId,
                    senderOfLastMessage: {
                        email: fullMessage.sender?.email,
                    },
                    otherUser: {
                        email: fullMessage.recipient?.email,
                        display_name: fullMessage.recipient?.display_name,
                        urlphoto: fullMessage.recipient?.urlphoto,
                    },
                    lastMessage: fullMessage.message,
                    unreadCount: 0,
                    is_read: true,
                    lastTimestamp: fullMessage.timestamp,
                });
            }

            state.selectedConversationId = convId;

            state.groupedMessages.push({
                type: "message",
                message: fullMessage,
            });
        },


        RECEIVED_ROOM_MESSAGE: (state, action) => {
            const msg = action.payload?.data ?? action.payload;
            const file_url = msg?.file_url ?? msg?.fileUrl ?? null;
            const file_name = msg?.file_name ?? msg?.fileName ?? null;
            const file_type = msg?.file_type ?? msg?.fileType ?? null;
            const file_size = msg?.file_size ?? msg?.fileSize ?? null;
            state.receivedMessages.push({
                id: msg.id,
                sender: msg.sender,
                message: msg.message,
                isRoomMessage: true,
                timestamp: msg.timestamp,
                conversation_id: msg.conversation_id,
                roomId: msg.roomId,
                roomTenantId: msg.roomTenantId,
                roomLabel: msg.roomLabel,
                file_url,
                file_name,
                file_type,
                file_size,
            });

            const idx = state.localConversations.findIndex(
                c => c.conversationId === msg.conversation_id
            );

            if (idx !== -1) {
                state.localConversations[idx].lastMessage = msg.message;
                state.localConversations[idx].lastTimestamp = msg.timestamp;
                state.localConversations[idx].unreadCount += 1;
                state.localConversations[idx].is_read = false;
            }

            if (state.selectedConversationId === msg.conversation_id) {
                state.groupedMessages.push({
                    type: "message",
                    message: normalizeMessage(msg)
                });
            }
        },

        MESSAGE_READ_UPDATE: (state, action) => {
            const conversationId =
                action.payload?.conversationId ??
                action.payload?.data?.conversationId;

            const readerEmail =
                action.payload?.readerEmail ??
                action.payload?.data?.readerEmail;


            if (!conversationId) return;

            const conv = state.localConversations.find(c => c.conversationId === conversationId);
            if (conv) {
                conv.is_read = true;
                conv.unreadCount = 0;
            }

            if (state.selectedConversationId === conversationId) {
                state.groupedMessages = state.groupedMessages.map(item => {
                    if (item.type !== "message") return item;

                    return {
                        ...item,
                        message: {
                            ...item.message,
                            is_read: true
                        }
                    };
                });
            }
        }


    },
    extraReducers: (builder) => {
        builder



            /////marks 
            .addCase(getUnreadConversationCount.pending, (state) => {
                state.error = null;
            })
            .addCase(getUnreadConversationCount.fulfilled, (state, action) => {
                state.UnreadConversationCount = action.payload.unreadConversationCount;
            })
            .addCase(getUnreadConversationCount.rejected, (state, action) => {
                state.error = action.payload || 'Failed to get Unread Conversation Count';
            })
            // Handle fetching conversation previews
            .addCase(getConversationPreviews.pending, (state) => {
                state.previewsLoading = true;
                state.error = null;
            })
            .addCase(getConversationPreviews.fulfilled, (state, action) => {
                state.previewsLoading = false;
                state.localConversations = action.payload.map(conv => {
                    const unread = state.unreadMessagesByConv.find(u => u.conversationId === conv.conversationId);
                    return {
                        ...conv,
                        unreadCount: unread ? unread.unreadCount : 0,
                        is_read: unread ? unread.unreadCount === 0 : true,
                    };
                });
            })

            .addCase(getConversationPreviews.rejected, (state, action) => {
                state.previewsLoading = false;
                state.error = action.payload || 'Failed to get conversation previews';
            })
            // Handle fetching messages for a selected conversation
            .addCase(getMessagesByConversation.pending, (state) => {
                state.messageLoading = true;
                state.error = null;
                state.groupedMessages = []; // Clear previous messages
            })
            .addCase(getMessagesByConversation.fulfilled, (state, action) => {
                state.groupedMessages = groupAllItemsByDate(action.payload);
                state.messageLoading = false;
            })

            .addCase(getMessagesByConversation.rejected, (state, action) => {
                state.messageLoading = false;
                state.error = action.payload || 'Failed to get messages for conversation';
                state.groupedMessages = [];
            })
            .addCase(getMessagesPaged.pending, (state) => {
                state.messageLoading = true;
            })
            .addCase(getMessagesPaged.fulfilled, (state, action) => {
                const { messages, sparks, encouragements, pagination } = action.payload;
                const grouped = groupAllItemsByDate(messages, sparks, encouragements);

                if (pagination.page === 1) {
                    state.groupedMessages = grouped;
                } else {
                    state.groupedMessages = [...grouped, ...state.groupedMessages];
                }

                state.pagination = pagination;
                state.messageLoading = false;
            })
            .addCase(getMessagesPaged.rejected, (state, action) => {
                state.messageLoading = false;
                state.error = action.payload || "Failed to load paged messages";
            })
            .addCase(getUnreadMessagesByConversation.fulfilled, (state, action) => {
                state.unreadMessagesByConv = action.payload.unread;
            })
            .addCase(searchMessagesPaged.pending, (state) => {
                state.messageLoading = true;
            })
            .addCase(searchMessagesPaged.fulfilled, (state, action) => {
                const { messages, sparks, encouragements, pagination } = action.payload;
                const grouped = groupAllItemsByDate(messages, sparks, encouragements);

                if (pagination.page === 1) {
                    state.groupedMessages = grouped;
                } else {
                    state.groupedMessages = [...grouped, ...state.groupedMessages];
                }

                state.pagination = pagination;
                state.messageLoading = false;
            })
            .addCase(searchMessagesPaged.rejected, (state, action) => {
                state.messageLoading = false;
                state.error = action.payload || "Search failed";
            });

    }
});

export const {
    setSelectedConversationId,
    clearMessages,
    intializeMessageDialog,
    resetMessageDialog,
    setMessageText,
    RECIEVE_MESSAGE,
    RECEIVED_ROOM_MESSAGE,
    REMOVE_ROOM_MESSAGE,
    MESSAGE_SUCCESS,
    MESSAGE_READ_UPDATE,
    setChatPartner
} = messagesSlice.actions;

socketFactory.on("receiveMessage", RECIEVE_MESSAGE);
socketFactory.on("messageSuccess", MESSAGE_SUCCESS);
socketFactory.on("messagesRead", MESSAGE_READ_UPDATE);
socketFactory.on("receiveRoomMessage", RECEIVED_ROOM_MESSAGE);

export const SEND_DIRECT_MESSAGE = socketFactory.emit('sendMessage', 'socket/sendMessage');
export const SEND_ROOM_MESSAGE = socketFactory.emit('sendMessageToRoom', 'socket/sendRoomMessage');
export const SEND_CONVERSATION_READ = socketFactory.emit("conversationRead", "socket/conversationRead");

export default messagesSlice.reducer;